import React, { useState } from 'react'
import { ApiDTO_NTSPform, useLinkCaseToParentMutation } from './Ntsp_Slice'

interface CaseLinkProps {
  form: ApiDTO_NTSPform
  setForm: React.Dispatch<React.SetStateAction<ApiDTO_NTSPform>>
  handleTabSwitch: (tab: any) => void
  handleSave: () => void
  isSaved: boolean
}

const CaseLink: React.FC<CaseLinkProps> = ({ form, setForm, handleTabSwitch, handleSave }) => {
  const [parentInput, setParentInput] = useState(form.ParentCaseId || '')
  const [linkCase, { isLoading: isLinking }] = useLinkCaseToParentMutation()
  const [statusMessage, setStatusMessage] = useState<{ type: 'success' | 'error' | '', text: string }>({ type: '', text: '' })

  const applyParent = async () => {
    if (!parentInput || parentInput === form.CaseId) return
    
    setStatusMessage({ type: '', text: '' })
    
    try {
      const result = await linkCase({
        CaseId: form.CaseId,
        ParentCaseId: parentInput
      }).unwrap()
      
      if (result.Success) {
        setForm(f => ({ ...f, ParentCaseId: parentInput }))
        setStatusMessage({ type: 'success', text: result.Message || 'Case successfully linked to parent' })
        // Optionally save the form
        //handleSave()
      } else {
        setStatusMessage({ type: 'error', text: result.Message || 'Failed to link case' })
      }
    } catch (error: any) {
      const errorMessage = error?.data?.Message || error?.data?.message || 'An error occurred while linking the case'
      setStatusMessage({ type: 'error', text: errorMessage })
      console.error('Error linking case:', error)
    }
  }

  const clearParent = async () => {
    if (!form.CaseId) return
    
    setStatusMessage({ type: '', text: '' })
    
    try {
      const result = await linkCase({
        CaseId: form.CaseId,
        ParentCaseId: '' // Empty string to unlink
      }).unwrap()
      
      if (result.Success) {
        setForm(f => ({ ...f, ParentCaseId: '' }))
        setParentInput('')
        setStatusMessage({ type: 'success', text: result.Message || 'Case successfully unlinked' })
      } else {
        setStatusMessage({ type: 'error', text: result.Message || 'Failed to unlink case' })
      }
    } catch (error: any) {
      const errorMessage = error?.data?.Message || error?.data?.message || 'An error occurred while unlinking the case'
      setStatusMessage({ type: 'error', text: errorMessage })
      console.error('Error unlinking case:', error)
    }
  }

  return (
    <div className="ntsp-form-container">
      <h5 className="mb-3">Case Link</h5>
      <div className="form-row mb-3">
        <label className="mr-2" style={{ minWidth: 140 }}>Current Case Id:</label>
        <span>{form.CaseId || 'N/A'}</span>
      </div>
      <div className="form-row mb-3">
        <label className="mr-2" style={{ minWidth: 140 }}>Parent Case Id:</label>
        <input
          className="form-control"
          style={{ maxWidth: 300, display: 'inline-block' }}
          value={parentInput}
          onChange={e => setParentInput(e.target.value)}
          placeholder="Enter parent case id"
        />
        <button
          className="ui-button app-button ml-2"
          disabled={!parentInput || parentInput === form.CaseId || isLinking}
          onClick={applyParent}
        >
          {isLinking ? 'Linking...' : 'Link'}
        </button>
        <button
          className="ui-button app-button negative ml-2"
            disabled={!form.ParentCaseId || isLinking}
            onClick={clearParent}
        >
          {isLinking ? 'Unlinking...' : 'Unlink'}
        </button>
      </div>
      {statusMessage.text && (
        <div className={`alert ${statusMessage.type === 'success' ? 'alert-success' : 'alert-danger'} mb-2`} role="alert">
          {statusMessage.text}
        </div>
      )}
      <div className="form-row mb-1">
        <small className="text-muted">
          Linking sets this case as child; parent case data may be referenced in reports.
        </small>
      </div>
      {form.ParentCaseId && (
        <div className="alert-info mt-3 p-2" style={{ background: '#eef', borderRadius: 4 }}>
          Linked to parent case: <strong>{form.ParentCaseId}</strong>
        </div>
      )}
      
    </div>
  )
}

export default CaseLink